import {handleActions} from 'redux-actions';
import actions from './coupons.actions';
import uuidv4 from 'uuid/v4';

const reducer = handleActions(
	{
		[actions.couponAdding]: (state = {}, {payload}) => {
			return {
				...state,
				adding: {
					couponUuid: uuidv4(),
					userUuid: payload.userUuid,
					communityUuid: payload.communityUuid,
					code: '',
					description: '',
					expiryDate: '',
					quantity: ''
				}
			};
		},
		[actions.couponDescAdding]: (state = {}, {payload}) => {
			return {
				...state,
				adding: {
					...state.adding,
					description: payload.description
				}
			};
		},
		[actions.couponProductLinkAdding]: (state = {}, {payload}) => {
			return {
				...state,
				adding: {
					...state.adding,
					productLink: payload.productLink
				}
			};
		},
		[actions.couponExpiryAdding]: (state = {}, {payload}) => {
			return {
				...state,
				adding: {
					...state.adding,
					expiryDate: payload.expiryDate
				}
			};
		},
		[actions.couponCodeAdding]: (state = {}, {payload}) => {
			return {
				...state,
				adding: {
					...state.adding,
					code: payload.code
				}
			};
		},
		[actions.couponQuantityAdding]: (state = {}, {payload}) => {
			return {
				...state,
				adding: {
					...state.adding,
					quantity: payload.quantity
				}
			};
		},
		[actions.couponAddingCanceled]: (state = {}, {payload}) => {
			return {
				...state,
				adding: null
			};
		},
		[actions.couponAdded]: (state = {}, {payload}) => {
			return {
				...state,
				adding: null,
				couponsPendingApproval: state.couponsPendingApproval
					? [payload.newCoupon[0], ...state.couponsPendingApproval]
					: []
			};
		},
		[actions.couponListing]: (state = {}, {payload}) => {
			return {
				...state,
				communityCoupons: [...payload.coupons]
			};
		},
		[actions.couponPendingApprovalListing]: (state = {}, {payload}) => {
			return {
				...state,
				couponsPendingApproval: [...payload.coupons]
			};
		},
		[actions.couponApproved]: (state = {}, {payload}) => {
			const approvedCoupon = state.couponsPendingApproval.filter(coupon => {
				return coupon.uuid === payload;
			});
			approvedCoupon[0].state = 'APPROVED';

			return {
				...state,
				couponsPendingApproval: state.couponsPendingApproval.filter(coupon => {
					return coupon.uuid !== payload;
				}),
				communityCoupons: [{...approvedCoupon[0]}, ...state.communityCoupons]
			};
		},
		[actions.couponRejected]: (state = {}, {payload}) => {
			return {
				...state,
				couponsPendingApproval: state.couponsPendingApproval.filter(coupon => {
					return coupon.uuid !== payload;
				})
			};
		},
		[actions.couponDeleted]: (state = {}, {payload}) => {
			if (payload.couponStatus === 'UNAPPROVED') {
				return {
					...state,
					couponsPendingApproval: state.couponsPendingApproval.filter(coupon => {
						return coupon.uuid !== payload.couponUuid;
					})
				};
			} else {
				return {
					...state,
					communityCoupons: state.communityCoupons.filter(coupon => {
						return coupon.uuid !== payload.couponUuid;
					})
				};
			}
		},
		[actions.couponRedeemed]: (state = {}, {payload}) => {
			return {
				...state,
				redeemed: payload,
				communityCoupons: state.communityCoupons.map(coupon => {
					if (coupon.uuid === payload.coupon.uuid) {
						coupon.redeemed = true;
						coupon.isBeingRedeemed = false;
					}

					return coupon;
				})
			};
		},
		[actions.couponRedeeming]: (state = {}, {payload}) => {
			return {
				...state,
				communityCoupons: state.communityCoupons.map(coupon => {
					if (coupon.uuid === payload.coupon.uuid) {
						coupon.isBeingRedeemed = true;
					}

					return coupon;
				})
			};
		},
		[actions.couponRedeemFailed]: (state = {}, {payload}) => {
			return {
				...state,
				communityCoupons: state.communityCoupons.map(coupon => {
					if (coupon.uuid === payload.coupon.uuid) {
						coupon.isBeingRedeemed = false;
					}

					return coupon;
				})
			};
		},
		[actions.couponEditing]: (state = {}, {payload}) => {
			return {
				...state,
				editing: payload.coupon,
				couponEditSection: payload.section
			};
		},
		[actions.couponDescEditing]: (state = {}, {payload}) => {
			return {
				...state,
				editing: {
					...state.editing,
					description: payload.description
				}
			};
		},
		[actions.couponExpiryEditing]: (state = {}, {payload}) => {
			return {
				...state,
				editing: {
					...state.editing,
					expiryDate: payload.expiryDate
				}
			};
		},
		[actions.couponProductLinkEditing]: (state = {}, {payload}) => {
			return {
				...state,
				editing: {
					...state.editing,
					productLink: payload.productLink
				}
			};
		},
		[actions.couponQuantityEditing]: (state = {}, {payload}) => {
			return {
				...state,
				editing: {
					...state.editing,
					quantity: payload.quantity
				}
			};
		},
		[actions.communityCouponUpdated]: (state = {}, {payload}) => {
			return {
				...state,
				coupons: state.communityCoupons.map(coupon => {
					// update coupon details in state as well
					if (coupon.uuid === payload.uuid) {
						coupon.description = payload.description;
						coupon.expiryDate = payload.expiryDate;
						coupon.quantity = payload.quantity;
					}
					return coupon;
				})
			};
		},
		[actions.pendingCouponUpdated]: (state = {}, {payload}) => {
			return {
				...state,
				coupons: state.couponsPendingApproval.map(coupon => {
					// update coupon details in state as well
					if (coupon.uuid === payload.uuid) {
						coupon.description = payload.description;
						coupon.expiryDate = payload.expiryDate;
						coupon.quantity = payload.quantity;
					}
					return coupon;
				})
			};
		},
		[actions.setCouponStatistics]: (state, {payload}) => ({
			...state,
			couponUuidForStatistics: payload.couponUuid,
			couponStatisticsSource: payload.source
		}),
		[actions.clearCouponStatistics]: (state, {payload}) => ({
			...state,
			couponUuidForStatistics: null,
			couponStatisticsSource: null
		})
	},
	null
);

export default reducer;



// WEBPACK FOOTER //
// ./src/community/coupons/coupons.reducer.js